var cov_19jqob9lk2 = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/document/preview/documentPreviewCtrl.js',
      hash = 'a5a3ebfa68ff0f0aad5405194b20690ff6088fb8',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/document/preview/documentPreviewCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 18,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 19
        },
        end: {
          line: 2,
          column: 30
        }
      },
      '2': {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 11,
          column: 5
        }
      },
      '3': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 10,
          column: 5
        }
      },
      '4': {
        start: {
          line: 5,
          column: 6
        },
        end: {
          line: 5,
          column: 25
        }
      },
      '5': {
        start: {
          line: 7,
          column: 6
        },
        end: {
          line: 7,
          column: 104
        }
      },
      '6': {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 13
        }
      },
      '7': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 14,
          column: 4
        }
      },
      '8': {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 78
        }
      },
      '9': {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 17,
          column: 4
        }
      },
      '10': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 19
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 56
          },
          end: {
            line: 1,
            column: 57
          }
        },
        loc: {
          start: {
            line: 1,
            column: 119
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 3,
            column: 70
          },
          end: {
            line: 3,
            column: 71
          }
        },
        loc: {
          start: {
            line: 3,
            column: 78
          },
          end: {
            line: 11,
            column: 3
          }
        },
        line: 3
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 12,
            column: 18
          },
          end: {
            line: 12,
            column: 19
          }
        },
        loc: {
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 12
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 18
          }
        },
        loc: {
          start: {
            line: 15,
            column: 29
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 15
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }, {
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }],
        line: 4
      },
      '1': {
        loc: {
          start: {
            line: 7,
            column: 27
          },
          end: {
            line: 7,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 7,
            column: 27
          },
          end: {
            line: 7,
            column: 44
          }
        }, {
          start: {
            line: 7,
            column: 48
          },
          end: {
            line: 7,
            column: 50
          }
        }],
        line: 7
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_19jqob9lk2.s[0]++;
angular.module('app').controller('documentPreviewCtrl', function ($scope, $state, $stateParams, $log, $CRUDService, $window) {
  cov_19jqob9lk2.f[0]++;

  var PATH_DOC = (cov_19jqob9lk2.s[1]++, 'Documents');
  cov_19jqob9lk2.s[2]++;
  $CRUDService.getAll(PATH_DOC, { get: 'single', id: $stateParams.id }, function (data) {
    cov_19jqob9lk2.f[1]++;
    cov_19jqob9lk2.s[3]++;

    if (data) {
      cov_19jqob9lk2.b[0][0]++;
      cov_19jqob9lk2.s[4]++;

      $scope.item = data;

      cov_19jqob9lk2.s[5]++;
      $scope.item.CORPS = ((cov_19jqob9lk2.b[1][0]++, $scope.item.CORPS) || (cov_19jqob9lk2.b[1][1]++, '')).replace('<i ', '<span ').replace('</i>', '</span>');

      cov_19jqob9lk2.s[6]++;
      return;
    } else {
      cov_19jqob9lk2.b[0][1]++;
    }
  });
  cov_19jqob9lk2.s[7]++;
  $scope.goback = function () {
    cov_19jqob9lk2.f[2]++;
    cov_19jqob9lk2.s[8]++;

    $state.go('document.document', { params: { idcl: $scope.item.IDCLASSEURS } });
  };
  cov_19jqob9lk2.s[9]++;
  $scope.print = function () {
    cov_19jqob9lk2.f[3]++;
    cov_19jqob9lk2.s[10]++;

    window.print();
  };
});